export default "__VITE_ASSET__20HVLMpP__"